
import { useState } from "react";
import { Card } from "@material-ui/core";
import { Alert, Avatar, Button, DialogActions, Divider, TextField, Typography } from "@mui/material";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import api from "../../services/api";
import LoadingShort from "../../load/loadingShort";
import ShortNome from "../../utils/ShortNome";
import DateHora from "../../utils/dateHora";
import TextoFormatado from "../../utils/textoFormatado";
import Editor from "../../ckeditor/editor";
import TextFormatado from "../../utils/TextFormatado";


export default function ResponseExpediente({ expediente, userId, setUpdate }) {
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [respostaExpediente, setRespostaExpediente] = useState('')
    const [open, setOpen] = useState(false)

    function handleChange(e) {
        e.target.files ?
            setRespostaExpediente({ ...respostaExpediente, [e.target.name]: e.target.files[0] })
            :
            setRespostaExpediente({ ...respostaExpediente, [e.target.name]: e.target.value })
    }

    const sendResposta = async () => {
        setUpdate(false)
        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        const formData = new FormData();
        formData.append('resposta', respostaExpediente?.conteudo);
        formData.append('anexoDespacho', respostaExpediente?.anexo);
        formData.append('expedienteId', expediente?._id);
        formData.append('userId', userId);

        await api.patch('/expediente/finalize', formData)
            .then(response => {
                setOpen(false)
                setMessageSuccess('Resposta enviada com sucesso e o expediente foi concluído')

                // api.patch('/expediente/change-status', { id, userId, 'status': 'Concluído' })
                setUpdate(true)

                // window.setTimeout(() => {
                //     navigate(-1)
                // }, 5000);

            }).catch(error => {
                // console.log(error)
                setOpen(false)
                setMessageError(error.response.data.message)
            })
    }


    return (
        expediente?.resposta ?
            <Card style={{ padding: 20, position: 'relative', marginTop: 10 }}>



                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={expediente.despachoPor?.dadosPessoais.fotoURL} style={{ marginRight: 5 }} />
                    <Typography lineHeight={1} noWrap variant="body1">
                        <ShortNome nome={expediente.despachoPor?.dadosPessoais?.nome} />
                        <br />
                        <small><DateHora date={expediente?.updatedAt} /></small>
                    </Typography>
                </div>
                <Typography variant="subtitle1" >
                    Resposta ao expediente.
                </Typography>
                <Divider />
                <TextFormatado texto={expediente?.resposta} />

                <iframe
                    id="pdfIframeExpedienteEsposta"
                    title={`PDF Viewer`}
                    src={[expediente?.anexoDespacho]}
                    width="100%"
                    height="800px"
                    style={{ border: 'none' }}
                />
            </Card>
            :
            <Card style={{ padding: 20, position: 'relative', marginTop: 10 }}>
                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && <MessageError message={messageError} />}

                <Typography style={{ lineHeight: 1.5, fontSize: 22, marginTop: 10 }} variant="h1">
                    Responder expediente
                </Typography>

                <br />
                <Editor
                    setEditorData={setRespostaExpediente}
                    editorData={respostaExpediente?.resposta}
                />

                {/* ANEXAR DOCUMENTOS COMPLEMENTARES */}

                <div align="center" style={{ border: '1px dashed', borderRadius: 5, marginTop: 10, marginBottom: 20 }}>
                    <label htmlFor="anexo" style={{ margin: 5, cursor: 'pointer' }} >

                        {respostaExpediente?.anexo ?
                            <>
                                <Typography variant="subtitle2" title="Alterar">
                                    <Alert severity="success">
                                        {respostaExpediente?.anexo?.name}
                                    </Alert>
                                </Typography>
                                <img src={URL.createObjectURL(respostaExpediente?.anexo)} alt="" width={'25%'} />
                            </>
                            :
                            <Typography variant="subtitle2" >
                                Adicionar anexo
                            </Typography>
                        }
                    </label>
                    <input accept="application/pdf, image/png, image/jpg, image/jpeg" type="file" name="anexo" id="anexo" style={{ display: 'none' }} onChange={handleChange} />
                </div>

                <DialogActions>
                    <Button disabled={!respostaExpediente?.conteudo || open} onClick={() => { sendResposta() }} size="small" variant="contained" style={{ background: '#85287e' }}>
                        {open ? <LoadingShort /> : 'Responder'}
                    </Button>
                </DialogActions>
            </Card>
    )
}